/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  sys-auth.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2025/12/05 11:33
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */
import { axiosAPIUrl, Parameter } from './index'

export interface StoreItem {
  // 公司唯一独立编号
  companyCode: string;
  // 店铺状态
  ccxStore: number;
  // 公司名称
  companyName: string;
  // 合作方公司编号
  partnerCompanyId: string;
  // 用户类型（0普通，1.超级管理员，2.股东）
  userOtherType: number;
  // 用户编号
  userId: string;
  // 店铺头像
  storeHeadPortrait: string;
  // 合作方邀请码
  versionCode: string;
  // 距离到期天数
  trial: number;
  // 店铺实体图
  storeEntityPicture: string;
  // 是否认证
  isIdentification: number;
  // 公司编号
  companyId: string;

  currentVersionCode: string;
  // 创建时间
  createTime: string;
  // 到期时间
  expirationTime: string;
  // 登录账户名
  loginName: string;
  // 是否过期
  isExpiration: number;
  // 店铺名称
  storeName: string;
}

/**
 * 获取店铺列表
 * @param parameter
 */
export function getStoreList(parameter: Parameter = {}, headers: any = {}) {
  return axiosAPIUrl<Ajax.Response<StoreItem[]>>({
    url: '/cykjoperation/companyQuery/getCcxStoreList',
    method: 'post',
    data: parameter,
    headers
  })
}

/**
 * 获取邀请列表
 * @param parameter
 */
export function getInvitationList(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjoperation/companyQuery/getUnCcxStoreList',
    method: 'get',
    params: parameter
  })
}

/**
 * 接受邀请
 * @param parameter
 */
export function acceptInvitation(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjoperation/companyManage/joinStore',
    method: 'post',
    data: parameter,
  })
}

/**
 * 拒绝邀请
 * @param parameter
 */
export function rejectInvitation(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjoperation/companyManage/refuseStore',
    method: 'post',
    data: parameter,
  })
}

/**
 * 解绑店铺
 * @param parameter
 */
export function unbindStore(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjoperation/companyManage/unBindStore',
    method: 'post',
    data: parameter,
  })
}

/**
 * 创建店铺
 * @param parameter
 */
export function createStore(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjoperation/companyManage/createStoreInfo',
    method: 'post',
    data: parameter,
    extraParams: {
      showLoading: false,
    },
  })
}

/**
 * 获取店铺信息
 * @param parameter
 */
export function getStoreInfo(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjoperation/companyManage/getStoreInfo',
    method: 'get',
    params: parameter,
  })
}

/**
 * 获取微店信息
 * @param parameter
 */
export function getMicroStoreInfo(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjoperation/companyManage/getOnlineStoreInfo',
    method: 'get',
    params: parameter,
  })
}

/**
 * 编辑店铺信息
 * @param parameter
 */
export function editStoreInfo(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjoperation/companyManage/updateStoreInfo',
    method: 'post',
    data: parameter,
  })
}

/**
 * 编辑微店信息
 * @param parameter
 */
export function editMicroStoreInfo(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjoperation/companyManage/updateOnlineStoreInfo',
    method: 'post',
    data: parameter,
  })
}

/**
 * 加入店铺
 * @param parameter
 */
export function joinStore(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjoperation/companyManage/joinStoreByAccount',
    method: 'post',
    data: parameter,
  })
}
